export default "__VITE_ASSET__ODiLwLqG__"